import React, { useEffect } from 'react';
import MainLayout from '../components/Layout/MainLayout.js';
import { updateMetaTags } from '../utils/metaTags.js';

const AboutPage = () => {
    useEffect(() => {
        updateMetaTags(
            'Om HåndværkerNet - Professionelle hjemmesider til håndværkere',
            'Lær mere om historien bag HåndværkerNet og vores mission om at give håndværkere en stærk online tilstedeværelse.'
        );
    }, []);

    return (
        <MainLayout>
            {/* Brug samme max-width som MainLayout (max-w-7xl) */}
            <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-2 gap-12 items-start mb-12">
                    <div>
                        <h1 className="text-4xl font-bold font-montserrat text-gray-900 mb-8">
                            Om HåndværkerNet
                        </h1>
                        
                        <div className="prose prose-lg">
                            <p>
                                HåndværkerNet er skabt af mig (Martin) med ét formål: 
                                At give danske håndværkere stærk online tilstedeværelse - nemt og billigt!
                            </p>
                        </div>
                    </div>
                    <div className="relative">
                        <img 
                            src="/images/landing/about-image.png" 
                            alt="Håndværker på arbejde" 
                            className="rounded-lg shadow-xl w-32"
                        />
                    </div>
                </div>
                
                {/* Fjern centrering ved at begrænse bredden */}
                <div className="prose prose-lg max-w-none">
                    <h2 className="text-2xl font-semibold font-montserrat text-gray-900 mt-12 mb-4">
                        Historien bag
                    </h2>
                    <p>
                        Det hele startede, da min lillebror, som er uddannet murer, overvejede 
                        at starte som selvstændig. Som mange andre håndværkere stod han over for 
                        udfordringen med at skulle etablere en professionel hjemmeside - en 
                        ofte dyr og tidskrævende proces.
                    </p>

                    <h2 className="text-2xl font-semibold font-montserrat text-gray-900 mt-12 mb-4">
                        Dine fordele
                    </h2>
                    <ul className="list-disc pl-6 space-y-4 mb-12">
                        <li>
                            <strong>Hurtig opsætning</strong> - Få din hjemmeside online på under 5 minutter
                        </li>
                        <li>
                            <strong>AI-genereret indhold</strong> - Professionelt indhold tilpasset din virksomhed
                        </li>
                        <li>
                            <strong>Nem administration</strong> - Brugervenligt kontrolpanel til opdatering af indhold
                        </li>
                        <li>
                            <strong>Start gratis</strong> - 3 måneders gratis prøveperiode uden binding
                        </li>
                        <li>
                            <strong>Gratis support</strong> - Få personlig hjælp når du har brug for det
                        </li>
                    </ul>

                    <h2 className="text-2xl font-semibold font-montserrat text-gray-900 mt-12 mb-4">
                        Missionen
                    </h2>
                    <p>
                        Jeg tror på, at alle håndværkere fortjener en professionel online 
                        tilstedeværelse uden at skulle bekymre sig om store omkostninger eller 
                        tekniske udfordringer. Med HåndværkerNet har jeg skabt en løsning, der 
                        kombinerer kunstig intelligens med brugervenligt design for at levere 
                        hjemmesider af høj kvalitet.
                    </p>
                </div>
            </div>
        </MainLayout>
    );
};

export default AboutPage;